import { render } from "./wysiwyg.vue?vue&type=template&id=3641c619"
import script from "./wysiwyg.vue?vue&type=script&lang=js"
export * from "./wysiwyg.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/wysiwyg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3641c619"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3641c619', __exports__)) {
    console.log('reload')
    api.reload('3641c619', __exports__)
  }
  
  module.hot.accept("./wysiwyg.vue?vue&type=template&id=3641c619", () => {
    console.log('re-render')
    api.rerender('3641c619', render)
  })

}


export default __exports__